import { Stack, Typography, alpha, useTheme } from '@mui/material';
import { Chip } from '@shared/components';

interface Props {
  name: string;
  value?: string | number;
  titleWidth?: number;
  chipWidth?: number;
}

export function CreateMarkupDialogRow({ name, value, titleWidth, chipWidth }: Props) {
  const theme = useTheme();
  const palette = theme.vars.palette;
  const infoTint = theme.vars
    ? `rgba(${theme.vars.palette.info.mainChannel} / 0.4)`
    : alpha(theme.palette.info.main, 0.4);

  return (
    <Stack flexDirection="row" gap={3} alignItems="center">
      <Typography width={titleWidth || 125} variant='body1'>
        {name}
      </Typography>

      <Chip
        backgroundColor={infoTint}
        textColor={palette.text.primary}
        sx={{ minWidth: 120, width: chipWidth, height: 40 }}
        label={value ?? '-'}
      />
    </Stack>
  );
}
